import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import './WithdrawalHistoryItem.scss';

const b = block('withdrawal-history-item');

const WithdrawalHistoryItem = ({ item }) => {
  const locale = useSelector(state => state.locale.locale);

  const displayedDate = item.date === 'Invalid Date' ? item.created_at : item.date;

  return (
    <section className={b()}>
      <div className={b('top')}>
        <div className={b('item')}>
          <div className={b('label')}>{locale.username}</div>
          <div className={b('value')}>{item.user_login}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.userId}</div>
          <div className={b('value')}>{item.user_id}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.date}</div>
          <div className={b('value')}>{displayedDate}</div>
        </div>
      </div>

      <div className={b('bottom')}>
        <div className={b('item')}>
          <div className={b('label')}>{locale.id}</div>
          <div className={b('value')}>{item.id}</div>
        </div>

        <div className={b('item')}>
          <div className={b('label')}>{locale.status}</div>
          <div className={b('value', { status: String(item.status).toLowerCase() })}>{item.status}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.newRequest}</div>
          <div className={b('value', { red: true })}>
            <span>{item.amount}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WithdrawalHistoryItem;
